import styled, { css } from 'styled-components';

const preserveVehicleImageAspectRatio = css`
  .ant-image,
  .ant-image-img,
  img {
    max-width: 100%;
    max-height: 100%;
    width: auto !important;
    height: auto !important;
    object-fit: contain;
  }
`;

export const VerticalCenter = styled.div<{
  isSmall?: boolean;
  $size?: number;
  $maxWidth?: number;
  $maxHeight?: number;
}>`
  margin: 0;
  width: ${({ $maxWidth, $size, isSmall }) => $maxWidth ?? $size ?? (isSmall ? 50 : 70)}px;
  height: ${({ $maxHeight, $size, isSmall }) => $maxHeight ?? $size ?? (isSmall ? 50 : 70)}px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${preserveVehicleImageAspectRatio}
`;

export const preserveCatalogVehicleImageAspectRatio = preserveVehicleImageAspectRatio;
